import { memo } from "react"

const FloatingButtonGroupHr = () => (
    <hr className="m-0 p-0 border-t-[1px] border-gray-200" />
);

export default memo(FloatingButtonGroupHr);
